/* globals require, $ */
'use strict';

var {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  BarElement,
  BarController,
  Tooltip,
} = require('chart.js');

Chart.register(
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  BarElement,
  BarController,
  Tooltip,
);

const tickFont = {
  family: '"opti sans", sans-serif',
  size: 11,
  weight: 'bold',
  color: '#545454',
};

$(function () {
  var active;

  var optiData = require('./page_performance_chart_data.json');

  optiData = optiData.map((data) => {
    data.value = data.value.map((point) => {
      point.timeStamp = Date.parse(point.date);
      return point;
    });
    return data;
  });

  var lineChart;
  var barChart;

  function toggleActive(id) {
    if (active) {
      active.toggleClass('active');
    }

    active = $(`#${id}`);
    active.toggleClass('active');

    $('#portfolioSelect').val(id);
  }

  var dateAlternatives = [
    { id: '2010-01-01', title: '2010', 'tick-size': 20000 },
    { id: '2000-01-01', title: '2000', 'tick-size': 50000 },
    { id: '1990-01-01', title: '1990', 'tick-size': 100000 },
    { id: '1980-01-01', title: '1980', 'tick-size': 1000000 },
    { id: '1970-01-01', title: '1970', 'tick-size': 1000000 },
  ];

  var currentPortfolioIndex = 'opti-9';
  var currentDateModel = dateAlternatives[0];
  var currentEndValue = 0;
  var currentYearValue = 2010;

  function updateGraph() {
    var currentTimeStamp = Date.parse(currentDateModel.id);
    var updateAnimationDuration = 350;

    if (!lineChart) {
      updateAnimationDuration = 0;
      lineChart = createLineGraph(
        filterByTimeStamp(optiData, currentTimeStamp),
        currentDateModel['tick-size'],
      );
    }

    var year = optiData.find((element) => element.id === currentPortfolioIndex);
    var values = year.value.filter(
      (element) => element.timeStamp > currentTimeStamp,
    );

    toggleActive(year.id);

    var timeSeries = valuesToTimeSeries(values);
    var labels = timeSeries.map((point) => point.date);

    // Line chart

    var dataset = lineChart.data.datasets[0];
    dataset.label = year.title;
    dataset.data = timeSeries.map(formatTotalReturn);
    dataset.tension = 0.4;

    let fromValue = currentEndValue;
    let toValue = dataset.data[dataset.data.length - 1];
    currentEndValue = toValue;

    $({ value: fromValue }).animate(
      { value: toValue },
      {
        duration: 300,
        step: function () {
          $('#endValue').html(formatHTMLValueToString(this.value));
        },
        complete: function () {
          $('#endValue').html(formatHTMLValueToString(toValue));
        },
      },
    );

    let fromYearValue = currentYearValue;
    let toYearValue = labels[0].substring(0, 4);
    currentYearValue = toYearValue;

    $({ value: fromYearValue }).animate(
      { value: toYearValue },
      {
        duration: 300,
        step: function () {
          $('#yearValue').html(Math.round(this.value));
        },
        complete: function () {
          $('#yearValue').html(Math.round(toYearValue));
        },
      },
    );

    lineChart.data.labels = labels;
    lineChart.update(updateAnimationDuration);

    // Bar chart

    if (!barChart) {
      barChart = createBarGraph(filterByTimeStamp(optiData, currentTimeStamp));
    }

    var barChartDataset = barChart.data.datasets[0];
    var data = formatBarGraphData(timeSeries);

    barChartDataset.data = data.map(formatYearReturn);
    barChartDataset.backgroundColor = data.map((point) =>
      point['year-return'] > 0 ? '#5DC2AD' : '#b0e6db',
    );

    barChart.data.labels = data.map((point) => point.date);
    barChart.update(updateAnimationDuration);
  }

  function changePortfolio(portfolioIndex) {
    currentPortfolioIndex = portfolioIndex;
    updateGraph();
  }

  function changeDate(date) {
    currentDateModel = dateAlternatives.find((model) => model.id === date);

    lineChart.destroy();
    lineChart = undefined;

    barChart.destroy();
    barChart = undefined;

    updateGraph();
  }

  // Set up portfolio picker

  function createOption(option) {
    return `<option value="${option.id}">${option.title}</option>`;
  }

  let portfolioSelect = $('#portfolioSelect');

  optiData.forEach(function (portfolio) {
    portfolioSelect.append(createOption(portfolio));
  });

  portfolioSelect.on('change', function () {
    changePortfolio(this.value);
  });

  // Set up date picker

  let dateSelect = $('#dateSelect');

  dateAlternatives.forEach((alternative) => {
    dateSelect.append(createOption(alternative));
  });

  dateSelect.on('change', function () {
    changeDate(this.value);
  });

  updateGraph();
});

function createBarGraph(optiData) {
  var allPoints = formatBarGraphData(
    optiData.flatMap((data) => valuesToTimeSeries(data.value)),
  );

  var barChartStepSize = 10;
  var barChartAllPoints = allPoints.flatMap(formatYearReturn);
  var barChartMinY =
    Math.floor(Math.min(...barChartAllPoints) / barChartStepSize) *
    barChartStepSize;
  var barChartMaxY =
    Math.ceil(Math.max(...barChartAllPoints) / barChartStepSize) *
    barChartStepSize;

  var ctx = document.getElementById('perYearChart').getContext('2d');

  return new Chart(ctx, {
    type: 'bar',
    data: { datasets: [{ backgroundColor: '#5DC2AD' }] },
    options: {
      legend: { display: false },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        tooltip: {
          displayColors: false,
          callbacks: {
            label: function (tooltipItem) {
              return `${tooltipItem.formattedValue} %`;
            },
          },
        },
      },
      scales: {
        x: {
          grid: { display: false, drawTicks: true, tickMarkLength: 20 },
          ticks: { maxTicksLimit: 10, font: tickFont },
        },
        y: {
          min: barChartMinY,
          max: barChartMaxY,
          grid: {
            display: true,
            color: (value) => {
              if (value.tick.value === 0) {
                return '#2C292E';
              }
              return '#eee';
            },
            lineWidth: 1,
            drawTicks: true,
            tickMarkLength: 10,
          },
          ticks: {
            font: tickFont,
            padding: 4,
            callback: function (value) {
              return value + ' %';
            },
          },
        },
      },
    },
  });
}

function createLineGraph(optiData, stepSize) {
  var allPoints = optiData.flatMap((data) => valuesToTimeSeries(data.value));

  var lineChartAllPoints = allPoints.flatMap(formatTotalReturn);
  var lineChartMinY =
    Math.floor(Math.min(...lineChartAllPoints) / stepSize) * stepSize;
  var lineChartMaxY =
    Math.ceil(Math.max(...lineChartAllPoints) / stepSize) * stepSize;

  var ctx = document.getElementById('performanceChart').getContext('2d');

  var gradient = ctx.createLinearGradient(0, 500, 0, 100);
  gradient.addColorStop(1, 'rgba(91, 197, 176, 0.1)');
  gradient.addColorStop(0, 'rgba(255, 255, 255, 0');

  return new Chart(ctx, {
    type: 'LineWithLine',
    data: {
      datasets: [
        {
          borderColor: '#55AF9A',
          backgroundColor: gradient,
          pointRadius: 0,
          pointHitRadius: 6,
          fill: true,
          responsive: true,
        },
      ],
    },
    options: {
      layout: { left: 8 },
      events: [
        'mousemove',
        'mouseout',
        'click',
        'touchstart',
        'touchmove',
        'touchend',
      ],
      interaction: { mode: 'nearest', axis: 'x', intersect: false },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        tooltip: {
          displayColors: false,
          mode: 'index',
          intersect: false,
          position: 'nearest',
          titleFontSize: 13,
          filter: function (tooltipItem) {
            return tooltipItem.datasetIndex === 0;
          },
          callbacks: {
            label: function (tooltipItem) {
              return formatValueToString(tooltipItem.raw);
            },
          },
        },
      },
      legend: { display: false },
      scales: {
        x: {
          grid: {
            display: true,
            color: (value) => {
              if (value.tick.value === 0) {
                return '#2C292E';
              }
              return '#f3f3f3';
            },
            lineWidth: 1,
            drawTicks: true,
            tickMarkLength: 10,
          },
          ticks: {
            padding: 8,
            font: tickFont,
            maxTicksLimit: 14,
            callback: function (value) {
              const label = this.getLabelForValue(value);
              if (label.substring(5, label.length) === '01-01') {
                return label.substring(0, 4);
              }
            },
          },
        },
        y: {
          min: lineChartMinY,
          max: lineChartMaxY,
          grid: {
            display: false,
            lineWidth: 0,
            drawTicks: true,
            tickMarkLength: 10,
          },
          type: 'linear',
          afterFit: function (scale) {
            scale.width = scale.width += 16;
          },
          ticks: {
            stepSize: stepSize,
            font: tickFont,
            padding: 8,
            callback: function (value) {
              return formatValueToString(value);
            },
          },
        },
      },
    },
  });
}

function formatValueToString(val) {
  return (
    Math.round(val)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr'
  );
}

function formatHTMLValueToString(val) {
  return (
    Math.round(val)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '&nbsp;') + '&nbsp;kr'
  );
}

function formatTotalReturn(point) {
  return Math.round(point['total-return'] * 100000);
}

function formatYearReturn(point) {
  return Math.round(point['year-return'] * 100 * 10) / 10;
}

function valuesToTimeSeries(value) {
  var out = [];
  value.forEach((value, index) => {
    if (index === 0) {
      out.push({
        date: value.date.substring(0, 4) + '-01-01', // Works for now
        'year-return': 0,
        'total-return': 1,
      });
    }
    var previous = out[out.length - 1]['total-return'];

    out.push({
      date: value.date,
      'year-return': value.value,
      'total-return': previous * (value.value + 1),
    });
  });

  return out;
}

function filterByTimeStamp(data, timeStamp) {
  var tmp = [];
  tmp = data.map((element) => {
    var tmp = Object.assign({}, element);
    tmp.value = element.value.filter(
      (element) => element.timeStamp > timeStamp,
    );
    return tmp;
  });
  return tmp;
}

Chart.defaults.LineWithLine = Chart.defaults.line;

class LineWithLine extends LineController {
  draw() {
    super.draw(arguments);

    var ctx = this.chart.ctx;

    // draw hover line
    if (this.chart.tooltip?.x !== undefined) {
      var x = this.chart.tooltip.caretX;
      var topY = this.chart.scales.y.top;
      var bottomY = this.chart.scales.y.bottom;

      // draw line
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, topY);
      ctx.lineTo(x, bottomY);
      ctx.lineWidth = 2;
      ctx.strokeStyle = 'rgba(0,0,0,0.2)';
      ctx.globalAlpha = this.chart.tooltip.opacity;
      ctx.stroke();
      ctx.restore();
    }

    // draw opti start
    let xAxis = this.chart.scales.x;
    let optiStartPosition0 = xAxis.getPixelForValue('2017-10-01');
    let optiStartPosition1 = xAxis.getPixelForValue('2018-01-01');
    let optiStartPosition = lerp(optiStartPosition0, optiStartPosition1, 0.5);

    ctx.save();
    ctx.beginPath();
    ctx.setLineDash([2, 2]);
    ctx.moveTo(optiStartPosition, this.chart.chartArea.top);
    ctx.lineTo(optiStartPosition, this.chart.chartArea.bottom);
    ctx.lineWidth = 2;
    ctx.strokeStyle = '#5dc2ad';
    ctx.stroke();
    ctx.restore();

    // draw baseline
    let yAxis = this.chart.scales.y;
    let baselinePixel = yAxis.getPixelForValue(100000);

    ctx.save();
    ctx.beginPath();
    ctx.setLineDash([5, 5]);
    ctx.moveTo(this.chart.chartArea.left, baselinePixel);
    ctx.lineTo(this.chart.chartArea.right, baselinePixel);
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(0,0,0,0.3)';
    ctx.stroke();
    ctx.restore();
  }
}
LineWithLine.id = 'LineWithLine';
LineWithLine.defaults = LineController.defaults;
Chart.register(LineWithLine);

function formatBarGraphData(timeSeries) {
  let data = [];
  let value = {};

  timeSeries.forEach((dataPoint) => {
    var yearReturn = value['year-return'];
    if (!yearReturn) {
      yearReturn = 1;
    }

    yearReturn *= 1 + dataPoint['year-return'];
    value['year-return'] = yearReturn;

    let currentYear = dataPoint['date'].substring(0, 4);

    if (currentYear !== value.date) {
      if (value.date !== undefined) {
        value['year-return'] -= 1;
        data.push(value);
      }
      value = { date: currentYear };
    }
  });

  if (value.date !== undefined) {
    value['year-return'] -= 1;
    data.push(value);
  }

  return data.filter((c) => !isNaN(c['year-return']));
}

function lerp(v0, v1, t) {
  return v0 * (1 - t) + v1 * t;
}
